import { API_BASE } from 'shared/constants/Api'

export const OPEN_PAYMENTS_CONSENT = `${API_BASE}/api/v2/marketplace/openpayments/consent/`
export const OPEN_PAYMENTS_VALIDATE = OPEN_PAYMENTS_CONSENT + 'validate/'
